import { render, staticRenderFns } from "./daifu_comp.vue?vue&type=template&id=46d671e9&scoped=true"
import script from "./daifu_comp.vue?vue&type=script&lang=js"
export * from "./daifu_comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d671e9",
  null
  
)

export default component.exports